import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LandingpageConfiguration } from '../models/landingpage-configuration.model';
import { CompletePaymentSepaDto } from '../models/dtos/complete-payment/complete-payment-sepa.dto';
import { environment } from '@environment/environment';
import { PaymentCheckout } from '../models/payment-checkout.model';
import { bypassClientErrorHandling } from './errors/error-bypass';

/**
 * BackendService is a service class that provides methods for interacting with the backend API.
 */
@Injectable({
  providedIn: 'root',
})
export class BackendService {
  private http = inject(HttpClient);

  /**
   * submitPersonalAccessToken is a method that sends a personal access token to the backend API.
   * @param personalAccessToken - External case identifier.
   */
  submitPersonalAccessToken(personalAccessToken: string) {
    return this.http.get<LandingpageConfiguration>(
      `${environment.apiURL}/eazi/api/payment/landingpage/${personalAccessToken}`,
      { context: bypassClientErrorHandling() },
    );
  }

  /**
   * createPaypalOrder is a method that instructs the backend to create an order via the PayPal API.
   * @param personalAccessToken - External case identifier.
   */
  createPaypalOrder(personalAccessToken: string) {
    return this.http.post<PaymentCheckout>(
      `${environment.apiURL}/eazi/api/payment/landingpage/${personalAccessToken}/paypal`,
      {},
      { context: bypassClientErrorHandling() },
    );
  }

  /**
   * capturePaypalOrder is a method that instructs the backend to finalize a PayPal transaction.
   * @param personalAccessToken - External case identifier.
   * @param orderId - PayPal order identifier
   */
  capturePaypalOrder(personalAccessToken: string, orderId: string) {
    return this.http.post(
      `${environment.apiURL}/eazi/api/payment/landingpage/${personalAccessToken}/paypal/${orderId}`,
      {},
      { context: bypassClientErrorHandling() },
    );
  }

  /**
   * completePaymentSepa is a method that sends sepa payment details to the backend API.
   * @param payload - Custom request body.
   */
  completePaymentSepa(payload: CompletePaymentSepaDto) {
    return this.http.post(`${environment.apiURL}/eazi/api/payment/landingpage/sepa`, payload, {
      context: bypassClientErrorHandling(),
    });
  }
}
